import {
  Box,
  DrawerBackdrop,
  DrawerContent,
  DrawerPositioner,
  DrawerRoot,
  Flex,
  Heading,
} from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import type { ReactNode } from "react";

export function BottomDrawer({
  open,
  onClose,
  title,
  children,
  minH,
}: {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
  minH?: string;
}) {
  return (
    <DrawerRoot
      open={open}
      onOpenChange={(d) => {
        if (!d.open) onClose();
      }}
      placement="bottom"
    >
      <DrawerBackdrop />
      <DrawerPositioner>
        <DrawerContent
          borderTopRadius="1rem"
          minH={minH ? `min(${minH}, 90dvh)` : undefined}
          maxH="90dvh"
          maxW="58rem"
          mx="auto"
          display="flex"
          flexDirection="column"
        >
          {title ? (
            <Flex
              justify="space-between"
              align="center"
              px="1.5rem"
              pt="1.25rem"
              pb="0.75rem"
              borderBottom="1px solid"
              borderColor="border.subtle"
            >
              <Heading as="h2" textStyle="headingBold">
                {title}
              </Heading>
              <Flex
                as="button"
                align="center"
                justify="center"
                w="2rem"
                h="2rem"
                borderRadius="full"
                bg="bg.subtle"
                border="0"
                cursor="pointer"
                flexShrink={0}
                onClick={onClose}
              >
                <FontAwesomeIcon icon={faXmark} />
              </Flex>
            </Flex>
          ) : (
            <Flex
              as="button"
              align="center"
              justify="center"
              w="2rem"
              h="2rem"
              borderRadius="full"
              bg="bg.subtle"
              border="0"
              cursor="pointer"
              position="absolute"
              top="0.75rem"
              right="0.75rem"
              zIndex="1"
              onClick={onClose}
            >
              <FontAwesomeIcon icon={faXmark} />
            </Flex>
          )}
          <Box p="1rem" overflowY="auto">
            {children}
          </Box>
        </DrawerContent>
      </DrawerPositioner>
    </DrawerRoot>
  );
}
